import React from "react";
import { Compass, EyeOff, LayoutList, Shuffle } from "lucide-react";
import { Button } from "../../ui/button";

const MODE = {
  next: { title: "What's next", Icon: Compass },
  surprise: { title: "Surprise me", Icon: Shuffle },
};

/**
 * The shape a selector picked, before generating: name and reason on the
 * left, Shuffle and Hide as icons on the right, so it stays one compact block.
 */
const PickCard = ({
  preview,
  onShuffle,
  onHide,
  pendingProgrammeSession,
  onOpenProgramme,
}) => {
  const archetype = preview?.archetype;
  if (!archetype) return null;
  const { title } = MODE[archetype.mode] || MODE.surprise;
  const isComplement = archetype.id.startsWith("complement:");
  const name = isComplement ? `Your goals, ${archetype.name}` : archetype.name;

  return (
    <div className="space-y-2 rounded-xl border border-primary/40 bg-primary/[0.07] p-3">
      <div className="flex items-start gap-2">
        <div className="min-w-0 flex-1">
          <p className="text-[11px] font-semibold uppercase tracking-[0.08em] text-primary">
            {title}
          </p>
          <p className="text-[15px] font-semibold leading-snug text-foreground">
            {name}
          </p>
        </div>
        <div className="-mr-1 -mt-0.5 flex shrink-0">
          <button
            type="button"
            onClick={onShuffle}
            aria-label="Shuffle"
            title="Shuffle"
            className="flex h-9 w-9 items-center justify-center rounded-lg text-foreground transition-colors hover:bg-primary/15"
          >
            <Shuffle className="h-[18px] w-[18px]" />
          </button>
          {!isComplement && onHide && (
            <button
              type="button"
              onClick={() => onHide(archetype.id)}
              aria-label="Never suggest this"
              title="Never suggest this"
              className="flex h-9 w-9 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-primary/15 hover:text-foreground"
            >
              <EyeOff className="h-[18px] w-[18px]" />
            </button>
          )}
        </div>
      </div>
      {archetype.reason && (
        <p className="text-xs leading-snug text-muted-foreground">
          {archetype.reason}
        </p>
      )}
      {pendingProgrammeSession && (
        <div className="flex items-center gap-2 rounded-lg border border-border/60 bg-background/40 px-2.5 py-2">
          <LayoutList className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
          <p className="min-w-0 flex-1 text-xs leading-snug text-muted-foreground">
            Your programme has{" "}
            <span className="font-medium text-foreground">
              {pendingProgrammeSession.label ||
                pendingProgrammeSession.scheduled_label ||
                "a session"}
            </span>{" "}
            up next.
          </p>
          {onOpenProgramme && (
            <Button
              type="button"
              size="sm"
              variant="outline"
              className="h-7 shrink-0 text-xs"
              onClick={onOpenProgramme}
            >
              Open
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default PickCard;
